import type { ISlotItem } from '@/entities/slot/types';
import { ShowCalendarProvider } from '@/features/product/contexts/ShowCalendarStoreContext';
import ProductListItem from '@/features/product/ui/ListItem';
import SlotListItemContent from '@/features/slot/ui/ListItemContent';
import useExpanded from '@/hooks/useExpanded';

interface IProps {
  item: ISlotItem;
}
export default function SlotSection({ item }: IProps) {
  const { idx: slotIdx, isExpanded, onToggleExpanded } = useExpanded();

  return (
    <ProductListItem
      key={item.idx}
      title={item.title}
      description={item.description}
      descriptionGoto={item.descriptionGoto}
      shouldShow={isExpanded && slotIdx === item.idx}
      isActive={item.isActive}
      isDisablePrice
      onToggleExpanded={onToggleExpanded(item.idx)}
    >
      <ShowCalendarProvider>
        <SlotListItemContent idx={item.idx} shouldShow={isExpanded && slotIdx === item.idx} />
      </ShowCalendarProvider>
    </ProductListItem>
  );
}
